import React, { useState, useEffect } from "react";
import "../user.scss";
import { Tabs, TabList, TabPanels, TabPanel, Tab } from "@carbon/react";
import { Gateway, UserIdentification, Star } from "@carbon/icons-react";
import { useGetFarmList } from "../../../hooks/useGetFarmList";
import UserAccounts from "../../../components/adminUser/userAccounts/UserAccounts";
import AgentTable from "../../../components/adminUser/agentTable/AgentTable";
import RequestsList from "../../../components/adminUser/requestsList/RequestsList";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";

export default function Admin() {
  const [activeTab, setActiveTab] = useState(0);

  const { t } = useTranslation();

  const { data: farmListData, isPending: isFarmListPending } = useGetFarmList();

  useEffect(() => {
    const tabNames = ["Farms", "Agents", "FuelRequests"];

    ReactGA.event("screen_view", {
      screen_name: `Admin_${tabNames[activeTab]}`,
      screen_class: "AdminPage",
    });
  }, [activeTab]);

  return (
    <div className="admin">
      <Tabs
        selectedIndex={activeTab}
        onChange={({ selectedIndex }) => setActiveTab(selectedIndex)}
      >
        <TabList contained aria-label="Admin Tabs">
          <Tab renderIcon={Gateway}>{t("admin.tabs.farms")}</Tab>
          <Tab renderIcon={UserIdentification}>{t("admin.tabs.agents")}</Tab>
          <Tab renderIcon={Star}>{t("admin.tabs.fuelRequests")}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <UserAccounts
              farmListData={farmListData}
              isFarmListPending={isFarmListPending}
            />
          </TabPanel>
          <TabPanel>
            {activeTab === 1 && <AgentTable farmListData={farmListData} />}
          </TabPanel>
          <TabPanel>{activeTab === 2 && <RequestsList />}</TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
}
